import React from 'react';
import { AlertTriangle, Package, ArrowUpRight, MessageSquare } from 'lucide-react';

interface MessageLimitModalProps {
  currentCount: number;
  maxCount: number;
  onClose: () => void;
}

const MessageLimitModal: React.FC<MessageLimitModalProps> = ({ currentCount, maxCount, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 text-white">
          <div className="flex items-center space-x-3">
            <div className="bg-white/20 p-2 rounded-full">
              <AlertTriangle className="w-6 h-6" />
            </div>
            <h2 className="text-xl font-bold">Límite de mensajes alcanzado</h2>
          </div>
        </div>
        
        {/* Content */}
        <div className="p-6">
          <div className="mb-4">
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div 
                className="bg-red-500 h-3 rounded-full" 
                style={{ width: `${Math.min((currentCount / maxCount) * 100, 100)}%` }}
              ></div>
            </div>
            <div className="flex justify-between text-sm text-gray-500 mt-1">
              <span>0</span>
              <span>{currentCount}/{maxCount} mensajes</span>
            </div>
          </div>
          
          <p className="text-gray-700 mb-6">
            Has alcanzado el límite de mensajes disponibles para tu suscripción actual. 
            Para continuar utilizando nuestros servicios, considera actualizar tu plan o 
            adquirir un paquete adicional de mensajes.
          </p>
          
          <div className="space-y-4">
            <div className="border border-blue-100 bg-blue-50 rounded-lg p-4">
              <h3 className="font-medium text-blue-800 flex items-center">
                <Package className="w-5 h-5 mr-2" />
                Actualiza tu suscripción
              </h3>
              <p className="text-blue-700 text-sm mt-1">
                Cambia a un plan superior para obtener más mensajes mensuales y 
                funcionalidades adicionales.
              </p>
              <button className="mt-3 bg-blue-600 text-white px-4 py-2 rounded-lg text-sm flex items-center hover:bg-blue-700 transition-colors">
                Ver planes disponibles
                <ArrowUpRight className="w-4 h-4 ml-1" />
              </button>
            </div>
            
            <div className="border border-purple-100 bg-purple-50 rounded-lg p-4">
              <h3 className="font-medium text-purple-800 flex items-center">
                <MessageSquare className="w-5 h-5 mr-2" />
                Compra mensajes adicionales
              </h3>
              <p className="text-purple-700 text-sm mt-1">
                Adquiere un paquete de mensajes adicionales para continuar 
                utilizando tu plan actual.
              </p>
              <button className="mt-3 bg-purple-600 text-white px-4 py-2 rounded-lg text-sm flex items-center hover:bg-purple-700 transition-colors">
                Comprar mensajes
                <ArrowUpRight className="w-4 h-4 ml-1" />
              </button>
            </div>
          </div>
        </div>
        
        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 flex justify-end">
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageLimitModal;